module.exports = __webpack_public_path__ + "img/active-students.195ae673.svg";